// Read requests for GET action
const Reads = {
  activity: 'catch_up',
  agentMerge: 'agent_merge',
  agentMergeSession: 'agent_merge_session',
  agentMergeStatus: 'agent_merge_status',
  annotations: 'annotations',
  artifacts: 'artifacts',
  assignees: 'assignees',
  availableReviewers: 'reviewers',
  baseComparisonInfo: 'base_comparison_info',
  changeGroups: 'change_groups',
  ciFindings: 'ci_findings',
  codeButton: 'code_button',
  codeowners: 'codeowners',
  commitMessageGenerationConfig: 'commit_message_generation_config',
  conversationComments: 'conversation_comments',
  development: 'development',
  threadPreviewPositioning: 'thread_preview_positioning',
  diffEntries: 'diff_entries',
  diffstat: 'diffstat',
  findings: 'findings',
  header: 'header',
  labels: 'labels',
  timeline: 'timeline',
  mergeBox: 'merge_box',
  mergeInstructions: 'merge_instructions',
  mergeRequestStatus: 'merge_request_status',
  participants: 'participants',
  pendingReview: 'pending_review',
  reviewRequests: 'review_requests',
  suggestedReviewers: 'suggested_reviewers',
  stackRebaseStatus: 'stack_rebase_status',
  stack: 'stacks',
  previewStack: 'preview_stack',
  statusChecks: 'status_checks',
  tabCounts: 'tab_counts',
  threadPreviews: 'thread_previews',
  threads: 'threads',
  diffViewUserSettings: 'user_diff_view_settings',
  diffContextLines: 'diff_entry_lines',
  richDiff: 'rich_diff',
  description: 'description',
  stackMergeability: 'stack_mergeability',
  fileTree: 'file_tree',
} as const

// Mutation requests for PUT, POST, PATCH, DELETE actions
const Mutations = {
  abandonReview: 'abandon_review',
  addCommentReaction: 'add_comment_reaction',
  addDescriptionReaction: 'description/add_reaction',
  changeBase: 'change_base',
  cleanupCodespaces: 'cleanup_codespaces',
  closePullRequest: 'close_pull_request',
  convertToDraft: 'convert_to_draft',
  createReviewComment: 'create_review_comment',
  createStackOrAppend: 'pull_request_stacks',
  deleteHeadRef: 'delete_head_ref',
  // deleteReviewComment: (id: number) => `review_comments/${id}`,
  dequeuePullRequest: 'dequeue_pull_request',
  disableAutoMerge: 'disable_auto_merge',
  dismissReview: 'dismiss_review',
  enableAutoMerge: 'enable_auto_merge',
  enqueueStack: 'enqueue_stack',
  generateChangeGroups: 'generate_change_groups',
  markReadyForReview: 'mark_ready_for_review',
  merge: 'merge',
  modifyAssignees: 'modify_assignees',
  modifyLabels: 'modify_labels',
  modifyReviewers: 'modify_reviewers',
  removeCommentReaction: 'remove_comment_reaction',
  removeDescriptionReaction: 'description/remove_reaction',
  reopenPullRequest: 'reopen_pull_request',
  restoreHeadRef: 'restore_head_ref',
  reRequestReviewFromUser: 're_request_review_from_user',
  resolveThread: 'resolve_thread',
  reviewMenu: 'review_menu',
  runActionRequiredWorkflows: 'run_action_required_workflows',
  stackRebase: 'stack_rebase',
  submitCopilotGroupsFeedback: 'submit_copilot_groups_feedback',
  submitFeatureFeedback: 'submit_feature_feedback',
  submitReview: 'submit_review',
  submitSuggestedChanges: 'apply_suggestions',
  applySuggestedChanges: 'apply_review_suggestions',
  submitPullRequestTimelineComment: 'create_timeline_comment',
  unresolveThread: 'unresolve_thread',
  unstackPullRequests: 'pull_request_stacks',
  updateAgentMerge: 'agent_merge',
  updateReviewComment: 'update_review_comment',
  updatePullRequestBranch: 'update_pull_request_branch',
  updateTitle: 'update_title',
  updateDescription: 'update_description',
  updateShowChangeGroupsPreference: 'update_show_change_groups_preference',
  updateMergeBoxUserPreference: 'update_merge_box_user_preference',
  updateWhitespacePreference: 'update_whitespace_preference',
  hideComment: 'hide_comment',
  unhideComment: 'unhide_comment',
} as const

export const PageData = {
  ...Reads,
  ...Mutations,
} as const

export type PageDataKey = keyof typeof PageData
export type PageDataName = (typeof PageData)[PageDataKey]

export const PageDataReadKeys = Object.values(Reads)
export const PageDataMutationKeys = Object.values(Mutations)
